import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { AlertErrorIcon, AlertInfoIcon, AlertSuccessIcon, AlertWarningIcon } from '../icons';
import { fromThemeColors } from '../Theme';
import { setDataAttributes } from '../util/getDataAttributes';
import { StyledAlert, StyledAlertAction, StyledInputAlert, StyledNotificationAlert } from './Alert.styled';
export function createAlert(alertType) {
  var StyledAlertType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : StyledAlert;
  var Icon = AlertInfoIcon;
  var alertColors;
  switch (alertType) {
    case 'Error':
      Icon = AlertErrorIcon;
      alertColors = {
        borderColor: fromThemeColors('errorBorder'),
        backgroundColor: fromThemeColors('errorBackground')
      };
      break;
    case 'Success':
      Icon = AlertSuccessIcon;
      alertColors = {
        borderColor: fromThemeColors('successBorder'),
        backgroundColor: fromThemeColors('successBackground')
      };
      break;
    case 'Warning':
      Icon = AlertWarningIcon;
      alertColors = {
        borderColor: fromThemeColors('warningBorder'),
        backgroundColor: fromThemeColors('warningBackground')
      };
      break;
    case 'Info':
    default:
      Icon = AlertInfoIcon;
      alertColors = {
        borderColor: fromThemeColors('infoBorder'),
        backgroundColor: fromThemeColors('infoBackground')
      };
  }
  var Alert = function Alert(props) {
    return /*#__PURE__*/React.createElement(StyledAlertType, _extends({}, alertColors, {
      onClick: props.onDismiss,
      role: props.onDismiss ? undefined : 'alert'
    }, setDataAttributes(props, alertType.toLowerCase())), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
      size: 24
    })), /*#__PURE__*/React.createElement("div", null, props.children), props.action && /*#__PURE__*/React.createElement(StyledAlertAction, props.action));
  };
  Alert.displayName = alertType;
  return Alert;
}
function createToast(alertType) {
  return createAlert(alertType, StyledNotificationAlert);
}
function createInputAlert(alertType) {
  return createAlert(alertType, StyledInputAlert);
}
export var WarningNotification = createToast('Warning');
export var ErrorNotification = createToast('Error');
export var InfoNotification = createToast('Info');
export var SuccessNotification = createToast('Success');
export var InputWarning = createInputAlert('Warning');
export var InputError = createInputAlert('Error');